<template>
  <div v-if="show" class="modal-overlay" @click.self="close">
    <div class="modal-content">
      <!-- ========================================== -->
      <!-- هدر -->
      <!-- ========================================== -->
      <div class="modal-header">
        <h3>📅 تنظیمات زمان‌بندی</h3>
        <button class="btn-close" @click="close">✕</button>
      </div>

      <!-- ========================================== -->
      <!-- اطلاعات ادمین و لاین -->
      <!-- ========================================== -->
      <div class="modal-info-bar">
        <div class="info-item">
          <span class="info-label">ادمین:</span>
          <span class="info-value">{{ adminName }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">لاین:</span>
          <span class="info-value">{{ lineName }}</span>
        </div>
      </div>

      <!-- ========================================== -->
      <!-- تب‌ها -->
      <!-- ========================================== -->
      <div class="tabs">
        <button
            :class="['tab-btn', { active: activeTab === 'schedule' }]"
            @click="activeTab = 'schedule'"
        >
          📅 الگوی هفتگی
        </button>
        <button
            :class="['tab-btn', { active: activeTab === 'auto' }]"
            @click="activeTab = 'auto'"
        >
          ⚡ ایجاد خودکار
        </button>
      </div>

      <!-- ========================================== -->
      <!-- محتوای تب‌ها -->
      <!-- ========================================== -->
      <div class="modal-body">
        <work-schedule-form
            v-if="activeTab === 'schedule'"
            :admin-id="adminId"
            :line-id="lineId"
            @saved="onScheduleSaved"
        />

        <auto-schedule-form
            v-if="activeTab === 'auto'"
            :admin-id="adminId"
            :line-id="lineId"
            @created="onAutoCreated"
        />
      </div>
    </div>
  </div>
</template>

<script>
import WorkScheduleForm from './WorkScheduleForm.vue';
import AutoScheduleForm from './AutoScheduleForm.vue';

export default {
  name: 'WorkScheduleModal',

  components: {
    WorkScheduleForm,
    AutoScheduleForm
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },
    adminId: {
      type: Number,
      required: true
    },
    lineId: {
      type: Number,
      required: true
    },
    adminName: {
      type: String,
      default: 'نامشخص'
    },
    lineName: {
      type: String,
      default: 'نامشخص'
    }
  },

  data: function() {
    return {
      activeTab: 'schedule'
    };
  },

  watch: {
    show: function(val) {
      if (val) {
        this.activeTab = 'schedule';
      }
    }
  },

  methods: {
    close: function() {
      this.$emit('close');
    },

    onScheduleSaved: function() {
      this.showSuccess('الگوی کاری ذخیره شد.');
      this.close();

    },

    onAutoCreated: function(data) {
      this.showSuccess(data.message);
      this.close();

    },

    showSuccess: function(msg) {
      if (this.$toast) this.$toast.success(msg);
      else alert(msg);
    }
  }
};
</script>

<style scoped>
/* ========================================== */
/* Overlay */
/* ========================================== */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
  direction: rtl;
}

.modal-content {
  background: white;
  border-radius: 14px;
  max-width: 800px;
  width: 100%;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
}

/* ========================================== */
/* هدر */
/* ========================================== */
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;
  flex-shrink: 0;
}

.modal-header h3 {
  margin: 0;
  color: #2c3e50;
  font-size: 17px;
}

.btn-close {
  background: none;
  border: none;
  font-size: 22px;
  cursor: pointer;
  color: #909399;
  line-height: 1;
}

.btn-close:hover {
  color: #2c3e50;
}

/* ========================================== */
/* اطلاعات ادمین و لاین */
/* ========================================== */
.modal-info-bar {
  display: flex;
  gap: 24px;
  padding: 12px 20px;
  background: #f8f9fa;
  border-bottom: 1px solid #f0f0f0;
  flex-shrink: 0;
  flex-wrap: wrap;
}

.info-item {
  display: flex;
  gap: 6px;
  font-size: 13px;
}

.info-label {
  color: #909399;
}

.info-value {
  color: #2c3e50;
  font-weight: 600;
}

/* ========================================== */
/* تب‌ها */
/* ========================================== */
.tabs {
  display: flex;
  gap: 4px;
  padding: 12px 20px 0 20px;
  background: white;
  border-bottom: 1px solid #f0f0f0;
  flex-shrink: 0;
}

.tab-btn {
  padding: 10px 20px;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 14px;
  color: #606266;
  font-weight: 500;
  border-bottom: 3px solid transparent;
  transition: all 0.2s;
  margin-bottom: -1px;
}

.tab-btn:hover {
  color: #409eff;
}

.tab-btn.active {
  color: #409eff;
  border-bottom-color: #409eff;
}

/* ========================================== */
/* بدنه */
/* ========================================== */
.modal-body {
  padding: 20px;
  overflow-y: auto;
  flex: 1;
}

/* ========================================== */
/* ریسپانسیو */
/* ========================================== */
@media (max-width: 768px) {
  .modal-overlay {
    padding: 10px;
  }

  .modal-content {
    max-height: 95vh;
    border-radius: 10px;
  }

  .modal-header {
    padding: 12px 16px;
  }

  .modal-info-bar {
    padding: 10px 16px;
    gap: 12px;
  }

  .tabs {
    padding: 10px 16px 0 16px;
  }

  .tab-btn {
    flex: 1;
    padding: 10px 8px;
    font-size: 13px;
  }

  .modal-body {
    padding: 14px;
  }
}
</style>